import React from "react";
import JoRequests from "../accounting/JoRequests";

const SuperAdminJoRequests = () => (
  <JoRequests
    portalLabel="Super Admin Portal"
    pageTitle="JO Requests"
    pageDescription="Review all active and nomination job orders and see immediately whether a request has already been submitted for each JO."
  />
);

export default SuperAdminJoRequests;
